<template>
  <div>
    <form @submit.prevent="submitForm">
      <h2>Rates are calculated based on shipment weight, size/dimension, distance and carrier service</h2>
      <div class="inputs-cover">
        <div>
          <label>Compare Rates</label>
          <input class="px-6 py-2" type="text" v-model="selectedRatesOptions">
        </div>
        <div>
          <label>Handling Fees</label>
          <input class="px-6 py-2" type="text" v-model="selectedRatesOptions">
        </div>
      </div>
      <h2>You can mark-up carrier generated rates to cover your packagingand handling costs</h2>
      <div class="inputs-cover">
        <div class="box-cover flex">
          <div class="color-box" :style="{ backgroundColor: isYellow ? '#FFA600' : '#FFFFFF' }"
            @click="toggleBackgroundColor"></div>
          <label class="ml-2">Percentage Markup <span> (i)</span></label>
        </div>
        <div>
          <input class="px-6 py-2" type="text" >
        </div>
      </div>
      <div class="inputs-cover">
        <div class="box-cover flex">
          <div class="color-box" :style="{ backgroundColor: isYellow ? '#FFA600' : '#FFFFFF' }"
            @click="toggleBackgroundColor"></div>
          <label class="ml-2">Flat Fee <span> (i)</span></label>
        </div>
        <div>
          <input class="px-6 py-2" type="text">
        </div>
      </div>
      <Actions />
    </form>
  </div>
</template>
  
<script>
import Actions from "@/components/EnterpriseCustomer/Settings/actions.vue";

export default {
  name: 'ShippingRates',
  components: {
        Actions,
    },
  data() {
    return {
      isYellow: false,
      isYellowOne: false,
      isYellowTwo: false,
      time: 'default',
      selectedRatesOptions: []
    };
  },
  methods: {
    submitForm() {
    },
    toggleBackgroundColor() {
      this.isYellow = !this.isYellow;
    },
    toggleBackgroundColorOne() {
      this.isYellowOne = !this.isYellowOne;
    },
    toggleBackgroundColorTwo() {
      this.isYellowTwo = !this.isYellowTwo;
    },
     back() {
      this.$router.go(-1)
    }
  }
};
</script>

<style scoped>
h2 {
  margin-bottom: 4%;
  margin-left: 5%;
  margin-top: 4%;
  color: rgba(252, 194, 16, 1);
}
span {
  color: rgba(252, 194, 16, 1);
  font-size: 12px;
  font-weight: 400;
}
.inputs-cover {
  /* border: 1px solid blue; */
  width: 85%;
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 4%; */
  padding-left: 5%;
}
.inputs-cover>div>input{
  /* border: 1px solid rgba(218, 232, 246, 1); */
  width: 100%;
  border-radius: 2px;
}
.inputs-cover>div>label{
  color: rgba(16, 35, 62, 1);
  font-size: 14px;
  font-weight: 400;
} 
.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  border: 1px solid #C5C4D4;
  cursor: pointer;
}
.box-cover {
  align-items: center;
}
</style>